import { Link } from "react-router-dom";
import { SERVICES } from "@/data/services";

export default function Services() {
  return (
    <section id="services" className="bg-sage-50/60">
      <div className="section">
        <div className="max-w-2xl">
          <p className="eyebrow">What we offer</p>
          <h2 className="mt-4 text-3xl sm:text-4xl">
            Thoughtful orthodontic care, tailored to you.
          </h2>
          <p className="mt-5 text-sage-700/90">
            Today's orthodontics offers more options than ever — from classic
            braces to nearly invisible aligners. Your visit always begins with
            a consultation so Dr. Amy can recommend the approach that fits
            your goals, lifestyle, and budget.
          </p>
        </div>

        <ul className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((service, idx) => (
            <li key={service.slug}>
              <Link
                to={`/services/${service.slug}`}
                className="group relative flex h-full flex-col overflow-hidden rounded-2xl border border-sage-100 bg-cream-50 p-7 transition hover:-translate-y-1 hover:border-blush-200 hover:shadow-soft"
              >
                <span
                  aria-hidden="true"
                  className="font-serif text-sm tracking-widest text-blush-300"
                >
                  {String(idx + 1).padStart(2, "0")}
                </span>
                <h3 className="mt-3 text-xl text-sage-800">{service.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-sage-700/90">
                  {service.shortDescription}
                </p>
                <span className="mt-5 inline-flex items-center gap-1 text-sm font-medium text-blush-500 transition group-hover:gap-2">
                  Learn more
                  <span aria-hidden="true">→</span>
                </span>
              </Link>
            </li>
          ))}
        </ul>

        <p className="mt-10 text-sm text-sage-700/80">
          Have a specific concern?{" "}
          <Link
            to="/#contact"
            className="font-medium text-blush-500 underline-offset-4 hover:underline"
          >
            Reach out
          </Link>{" "}
          and we'll talk through your options.
        </p>
      </div>
    </section>
  );
}
